import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-sngp',
  templateUrl: './coachtraining-sngp.component.html',
  styleUrls: ['./coachtraining-sngp.component.scss']
})
export class CoachtrainingSngpComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
